import APIService from '@/api'

export default class APITown extends APIService{

    constructor(){
        super('towns')
    }

    getAll() {
        var response = this.AxiosInstance
            .get(this.ApiUrl)
            .catch(error => {
              console.log(error.response)
            });
        return response;
    }
}


// WEBPACK FOOTER //
// ./src/api/town.js